import { cnvrtStringDateToNormalDateObj } from "./utils";

export const sanitizeDecimalValue = (input) => {
  return input.replace(/[^0-9\.]+/g, "");
};

export const updateDecimalInputOnState = (
  updatedValue,
  maxLength,
  updatedField,
  updatedType,
  updateFunction
) => {
  const valueToBeUpdated = sanitizeDecimalValue(updatedValue);
  if (
    (updatedField === "finRate" && valueToBeUpdated > 100) ||
    valueToBeUpdated.length > maxLength
  ) {
    return;
  }
  updateFunction(updatedField, valueToBeUpdated, updatedType);
};

const onclickValidationHandler = (props) => {
  let errorFields = [];
  const trans = props.transactions;
  EmptyFieldValidation("customerName", errorFields, trans, "Customer Name");
  EmptyFieldValidation("dealMarket", errorFields, trans, "Market Segment");
  EmptyFieldValidation("dealType", errorFields, trans, "Deal Type");
  emptyFieldValidationForNumericalValue(
    "quantity",
    errorFields,
    trans,
    "Quantity"
  );
  EmptyFieldValidation("dealResult", errorFields, props.bids, "Deal Result");
  EmptyFieldValidation("saleReason", errorFields, props.bids, "Sale Reason");
  EmptyFieldValidation(
    "paymentType",
    errorFields,
    props.paymentType,
    "Payment Method"
  );
  EmptyFieldValidation("txnDate", errorFields, trans, "Transaction Date");
  EmptyFieldValidation("compBids", errorFields, trans, "Competitive Bids");
  EmptyFieldValidation(
    "dealerAccountId",
    errorFields,
    props.transactionRequest,
    "Dealer Account"
  );
  EmptyFieldValidation("currency", errorFields, props.bids, "Currency");
  salesPersonIdFieldValidation(
    "salePersonID",
    errorFields,
    "SalesPerson ID",
    props
  );
  EmptyFieldValidation(
      "salesPersonName",
      errorFields,
      trans,
      "SalesPerson Name"
  );
  CheckAverageFieldValidation(
    "dlrMarginPct",
    errorFields,
    props.bids,
    "Reported Dealer Margin"
  );
  props.transactions.bids.forEach((bid) => {
    EmptyFieldValidation(
      "saleAmtPerUnit",
      errorFields,
      bid,
      `${bid.bidType} Sale / Quote Amount`
    );
    EmptyFieldValidation("model", errorFields, bid, `${bid.bidType} Model`);
    EmptyFieldValidation(
      "make",
      errorFields,
      bid,
      `${bid.bidType} Manufacturer`
    );
  });
  return errorFields;
};

const EmptyFieldValidation = (field, errorFields, fieldObject, errorText) => {
  if (fieldObject[field] === undefined || fieldObject[field] === "") {
    errorFields.push(errorText);
  }
};

const emptyFieldValidationForNumericalValue = (
  field,
  errorFields,
  fieldObject,
  errorText
) => {
  if (
    fieldObject[field] === undefined ||
    fieldObject[field] === "" ||
    fieldObject[field] === 0
  ) {
    errorFields.push(errorText);
  }
};

const salesPersonIdFieldValidation = (field, errorFields, errorText, props) => {
  let id = props.transactions[field];
  if (
    id === undefined ||
    id === "" ||
    id.length !== 7 ||
    id.substring(0, 1).toUpperCase() !== "X"
  ) {
    errorFields.push(errorText);
  }
};
const CheckAverageFieldValidation = (
  field,
  errorFields,
  fieldObject,
  errorText
) => {
  if (!(fieldObject[field] >= 0 && fieldObject[field] <= 30)) {
    errorFields.push(errorText);
  }
};

export const onSubmitHandler = (props) => {
  return onclickValidationHandler(props);
};

export const bidResultValidator = (props) => {
  let bidWonCount = 0;
  props.transactions.bids.forEach((bid) => {
    if (bid.dealResult === "Won") {
      bidWonCount++;
    }
  });
  return bidWonCount === 1;
};

export const sortDropdownByDisplayOrder = (options) => {
  let sortedOptions = options.sort((p1, p2) =>
    p1.displayOrder > p2.displayOrder
      ? 1
      : p1.displayOrder < p2.displayOrder
      ? -1
      : 0
  );
  return sortedOptions;
};

export const onSubmitWarningAlert = (props) => {
  const { bids, texts, transactions, transactionAttachments } = props;

  const calcFinalSpreadPct = parseFloat(bids?.calcFinalSpreadPct);
  const preDate = new Date();
  preDate.setDate(preDate.getDate() - 90);
  const postDate = new Date();
  postDate.setDate(postDate.getDate() + 60);

  const warningAlerts = [];
  const txnDateObj = cnvrtStringDateToNormalDateObj(transactions?.txnDate);

  if (txnDateObj < preDate || txnDateObj > postDate) {
    warningAlerts.push(texts.DATE_VALIDATION_MSG);
  }
  if (
    calcFinalSpreadPct &&
    (calcFinalSpreadPct >= 40.0 || calcFinalSpreadPct <= -40.0)
  ) {
    warningAlerts.push(texts.SPRD_MARGIN_PER_VALID_MSG);
  }

  const filesToBeDeleted = transactionAttachments.filter(
    (fileObj) => fileObj.fileStatus === "DELETED" && fileObj.fileId
  );
  const filesToBeReplaced = filesToBeDeleted.filter((dltFle) =>
    transactionAttachments
      .filter((allFiles) => allFiles.fileStatus !== "DELETED")
      .some((extFle) => extFle.fileName === dltFle.fileName)
  );
  const filesToBeOnlyDeleted = filesToBeDeleted.filter(
    (fileObj) => !filesToBeReplaced.includes(fileObj)
  );
  if (filesToBeDeleted.length > 0) {
    if (filesToBeOnlyDeleted.length > 0) {
      const deletedFilesMsg = `${texts.DEL_ATTACH_MSG} ${filesToBeOnlyDeleted
        .map((fileObj) => fileObj.fileName)
        .join(", ")}.`;
      warningAlerts.push(deletedFilesMsg);
    }
    if (filesToBeReplaced.length > 0) {
      const replacedFilesMsg = `${texts.OVRT_ATTACH_MSG} ${filesToBeReplaced
        .map((fileObj) => fileObj.fileName)
        .join(", ")}.`;
      warningAlerts.push(replacedFilesMsg);
    }
  }

  return { warningAlerts, filesToBeDeleted };
};

export const getUserName = (user) => {
  let userName = "";
  if (user) {
    if (user["firstName"]) userName = user["firstName"];
    if (user["lastName"]) userName += " " + user["lastName"];
  }
  return userName;
};

export const hasRole = (expectedRole, props) => {
  const userDetails = props.isSimulateMode
    ? props.simulatedUserDetails
    : props.userDetails;

  const authorizedRoles = userDetails?.authorizedRoles;
  return (
    authorizedRoles && Object.values(authorizedRoles).includes(expectedRole)
  );
};
export const getUserObj = (props) => {
  return props.isSimulateMode
      ? props.simulatedUserDetails
      : props.userDetails;
};
